<template>
	<div style="background-color: #f3f8fc;">
		<Header :sel='type' @changePhone="changePhone" />

		<!--新闻中心-->
		<!-- * 内页banner * -->
		<div class="page-banner">
			<img src="@/assets/images/banner03.png">
			<div class="nybt">
				<h3>新闻资讯</h3>
			</div>
		</div>
		
		<!-- * 当前位置 * -->
		<div class="page-position">
			<div class="wh">
				当前位置：
				<a href="/">首页</a>
				&gt;
				集团动态 > {{title}}
			</div>
		</div>
		
		<!-- * 主体部分 * -->
		<div class="page-wrap">
			<div class="wh clearfix">
			
		
				<!-- * 右侧 * -->
				<div class="page-wrap-right">
		
					<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
						<div>
							
							<ul class="xypg-left-nav">
								<li :class="item.code==type?'clicked':''" v-for="item in actList">
									<a href="javascript:void(0)"
											@click="changeData(item.code,item.name)">
									{{item.name}}</a>
									<div class="first-nav-btn"></div>
								</li>
								<!-- <li class="clicked">
									<a href="03集团动态 01 新闻列表.html">
										新闻中心</a>
									<div class="first-nav-btn"></div>
								</li> -->
							
							</ul>
						</div>
					</div>
		
		
		
					<div class="xypg-right-content">
						<div>
							<!-- 新闻列表页 -->
							<ul class="xypg-news-list">
								<li v-for="item in list">
									<a href="javascript:void(0)" @click="goDetail(item.id, item.categoryName)" :title="item.title">
										<div class="new_news">
										<div  class="new_news_img"><img :src="item.image" ></div>
										<div class="new_news_con"><div class="tit">
											<h3>{{item.title}}</h3>
											<div class="date">{{item.publishTime}}</div>
										</div>
										<div class="info">
											{{item.describtion}}
										</div>
										<div class="more"><span>More +</span></div></div>
</div>
										
									</a></li>
								
							</ul>
						</div>
		
						<div class="xypg-pagination">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="pageNum" :page-sizes="[10, 20, 50, 100]"
								:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
								:total="total">
							</el-pagination>
						</div>
					</div>
				</div>
		
				<!-- * 手机弹窗 * -->
			
			</div>
		</div>
		<Footer></Footer>



	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		categorysortPage,
		articleList,
		articleDetail
	} from '@/api/reqFetch.js'
	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				tabList: [],
				selName: '',
				selid: '0',
				list: [],
				pageNum: 1,
				totalPage: 0,
				pageSize:10,
				showPhone: false,
				type: '',
				categoryCode: '',
				configList: [],
				selOneName: '',
				title: '',
				total: 0,
				level: 1,
				firstCategoryCode: '',
				pos: '',
				xhDetail: {},
				id: '',
				actList:[{
					name:'新闻中心',
					code:'200007'
				},{
					name:'政策资讯',
					code:'200006'
				}],
				type:'200007',
				title:'新闻中心',
			}
		},

		mounted() {
			if(this.$route.query.type){
				this.type=this.$route.query.type
				this.title=this.$route.query.title
			}
			
			this.getData()

		},

		methods: {
			changeData(id, title) {
				let url = '/newList?type=' + id + '&title=' + title
				this.$router.push(url)
				this.$router.go(0)
			},
			
			changePhone(val) {
				this.showPhone = val
			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},
			
			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode:this.type
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
				});
			},
			goDetail(id,name) {
				this.$router.push({
					path: '/context',
					query: {
						id: id,
						name:name
					}
				});
				// window.open(route.href);
			},
			

		}
	}
</script>

<style scoped>
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}
</style>